import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEService } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEService';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BEServiceAction } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MDExtendService } from '../../../MD/MDExtendService';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointServiceShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointServiceShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_Service.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEService, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.serviceActions, false);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_SERVICE;
  }

  get service(): BEService {
    return this.element() as BEService;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加服务操作
      case 'shape:addServiceAction':
        element = this.addServiceAction();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType === MDAConstant.Link.ADD_COMPOSITION || linkType === MDAConstant.Link.ADD_AGGREGATION || linkType === MDAConstant.Link.ADD_GENERALIZATION ||
        linkType === MDAConstant.Link.ADD_ASSOCIATION || linkType === MDAConstant.Link.ADD_DEPENDENCY || linkType === MDAConstant.Link.ADD_IMPLEMENT) {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  private addServiceAction(): BEServiceAction {
    const action = MDRepository.createBEServiceAction(this.service);
    MDExtendService.setElementListSequence(this.service.serviceActions, true);
    this.model().compartments[0].push(action);
    return action;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.service.serviceActions.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.service.serviceActions.splice(this.service.serviceActions.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(service: BEService, isCollapse = false): ShapeModel {
    const model = new ShapeModel(service, isCollapse);
    model.addCompartment(service.serviceActions.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointServiceShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEService();
    newElement.copyFrom(this.service, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.services.push(newElement);
    }

    this.service.serviceActions.forEach(item => {
      const parameter = new BEServiceAction();
      parameter.copyFrom(item, false);
      MDExtendService.setCreateInfo(parameter);
      parameter.service_ID = newElement.id;
      newElement.serviceActions.push(parameter);
      elements.push(parameter);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): BEServiceAction | null {
    let newElement: BEServiceAction | null = null;
    if (element instanceof BEServiceAction) {
      newElement = new BEServiceAction();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.service_ID = this.service.id;
      this.service.serviceActions.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 服务
   *    - 必须包含至少一个服务操作
   * 2. 服务操作
   *    - 必须设置外部服务或者商业逻辑
   *    - 不能存在同名操作
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.service.designId;
    MDValidation.validateBaseElement(this.service, containerDesignId, true, errors);
    if (this.service.serviceActions.length === 0) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `服务 [${this.service.displayName}] 必须包含至少一个服务操作`));
    } else {
      this.service.serviceActions.forEach((element) => {
        MDValidation.validateBaseElement(element, containerDesignId, true, errors);
        if (ValidateHelper.IsNotNullOrEmpty(element.externalService_ID) && ValidateHelper.IsNotNullOrEmpty(element.businessLogic_ID)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `服务 [${this.service.displayName}] 的操作 [${element.displayName}] 必须设置外部服务或者商业逻辑`));
        }
        if (this.service.serviceActions.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `服务 [${this.service.displayName}] 不能存在同名操作 [${element.name}]`));
        }
      });
    }
    return errors;
  }
}
